import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import { Container, Row, Col, Input, Button, FormGroup, Label, UncontrolledTooltip} from 'reactstrap';
import Pagination from 'react-js-pagination';
import MaterialIcon from 'material-icons-react';
import moment from 'moment';
import i18n from "../../../i18next";

import { loadCustomerAutomationSearch, blockUnblockCustomer, checkAddCustomer, addCustomer, clearCustomerToAdd } from '../../../actions/index'
import { DEFAULT_PAGE_SIZE, DEFAULT_PAGING_RANGE } from "../../../utils/Constants";
import AutoCompleteSearch from '../../central/autosearch/AutoCompleteSearch';

class CustomerSearch extends React.Component {

    state = {
        searchQuery: {
            name: '',
            email: '',
            formattedPhone: '',
            blocked: ''
        },
        currentPageNumber: 0,
        customerPhone: '',
        isCustomerToAddFound: false
    }

    componentDidUpdate(prevProps) {
        if (prevProps.customerToAdd !== this.props.customerToAdd) {
            this.props.customerToAdd && this.setState({ ...this.state, isCustomerToAddFound: true })
            !this.props.customerToAdd && this.setState({ ...this.state, isCustomerToAddFound: false })
        }
    }

    removeActivePromoCodesInfo() {

        if ((this.props.customers && this.props.customers.content) && this.props.customers.content.length > 0) {
            this.props.customers.content.map((customer, i) => {
                    const customerInformationRow = `customerInformationRow${customer.id}`;
                    const promoCodesInformationRow = `promoCodesInformationRow${customer.id}`;

                    const table = document.querySelector(`#${customerInformationRow}`)
                    const item = document.querySelector(`#${promoCodesInformationRow}`);

                    if([...table.classList].includes('activeCustomerInformationRow')) {
                        console.log('INSIDE REMOVE')
                        table.classList.remove('activeCustomerInformationRow');
                        item.style.display = 'none';
                        table.style.borderBottom = '1px solid rgb(222, 226, 230)';
                    }
            })
        }
    }

    handlePageChange = pageNumber => {
        this.setState({
            currentPageNumber: (pageNumber - 1)
        }, () => this.props.loadCustomerAutomationSearch(this.props.maId, this.state.currentPageNumber, this.props.brandId, this.state.searchQuery));

        this.removeActivePromoCodesInfo()
    }

    togglePromocodesInfo = (customerInformationRow, promoCodesInformationRow) => {

        const table = document.querySelector(`#${customerInformationRow}`)
        const icon = table.querySelector('i');
        const item = document.querySelector(`#${promoCodesInformationRow}`);
        
        if (![...table.classList].includes('activeCustomerInformationRow')) {
            if (item.id === promoCodesInformationRow) {
                table.classList.add('activeCustomerInformationRow');
                item.style.display = 'block';
                icon.textContent = 'do_not_disturb_on';
                table.style.borderBottom = '';
            } 
        } else {
            if(item.id === promoCodesInformationRow) {
                table.classList.remove('activeCustomerInformationRow');
                icon.textContent = 'add_circle';
                item.style.display = 'none';
                table.style.borderBottom = '1px solid rgb(222, 226, 230)';
            } 
        }
    }

    changeState = (e, inputData, inputName) => {
        if (!e) {
                this.setState({
                    searchQuery: {
                        ...this.state.searchQuery,
                        [inputName]: inputData[inputName]
                    }
                });
        } else {
            if (e.target.name === 'customerPhone') {
                this.setState({ ...this.state, [e.target.name]: e.target.value }
                )
            } else {
                this.setState({
                    searchQuery: {
                        ...this.state.searchQuery,
                        [e.target.name]: e.target.value
                    }
                });
            }
        } 
    }

    changeAddCustomerState = () => {
       this.setState({ 
            ...this.state, 
            isCustomerToAddFound: false, 
            customerPhone: '',
            customers: this.props.customers });
    }

    updateCheckboxState = ({ target }) => {
        if (target.value === 'true') {
            this.setState({
                searchQuery: {
                    ...this.state.searchQuery,
                    checked: false
                }
            });
        } else {
            this.setState({
                searchQuery: {
                    ...this.state.searchQuery,
                    checked: true
                }
            });
        }
    };
    
    onBackCustomerFilters = () => {
        this.props.toggleAddCustomerListModalOpen();
        this.setState({ ...this.state, customerPhone: '' });
    }

    onCancelAddCustomer = () => {
        this.props.clearCustomerToAdd();
        this.props.toggleAddCustomerListModalOpen();
        this.changeAddCustomerState();
    }

    onAddCustomer = () => {
        this.props.addCustomer(this.props.maId, this.props.customerToAdd.id, () => {
            this.props.loadCustomerAutomationSearch(this.props.maId, this.state.currentPageNumber, this.props.brandId, this.state.searchQuery)
        });
        this.props.clearCustomerToAdd();
        this.props.toggleAddCustomerListModalOpen();
        this.changeAddCustomerState();
    }

    onClickSubmitButtonAction = () => {
        if(this.props.isAddCustomerListModalOpen) {
            this.props.checkAddCustomer(this.props.maId, this.state.customerPhone);
        } else {
            this.props.loadCustomerAutomationSearch(this.props.maId, this.state.currentPageNumber, this.props.brandId, this.state.searchQuery)
            this.removeActivePromoCodesInfo()
        }
    }

    blockUnblock = (customer) => {
        // console.log(customer.id, 'CUSTOMER ID')
        this.props.blockUnblockCustomer(customer.id, !customer.blocked);
    }

    renderProductSummaryTable = () => {
        return (
            <Row style={{ marginTop: '25px', display: 'block' }}>
                    {this.renderTableHeaders()}
                    {this.renderTableContent()}
            </Row>
        );
    }

    renderTableHeaders = () => {
        const { headerContainer } = styles;
        if (this.props.isAddCustomerListModalOpen) {
            return (
                <Col style={{ padding: '0px' }}>
                <Row style={{...headerContainer, backgroundColor: '#f8f8f8', padding: '10px 0', borderBottom: 'none'}}>
                    <Col xs={4}>{i18n.t('screens:marketingAutomationScreen.customerName')}</Col>
                    <Col xs={4}>{i18n.t('screens:marketingAutomationScreen.customerEmail')}</Col>
                    <Col xs={4}>{i18n.t('screens:marketingAutomationScreen.customerPhone')}</Col>
                </Row>
                </Col>
            )
        } else {
           
            return (
                <Col style={{ padding: '0px' }}>
                <Row style={{...headerContainer, backgroundColor: '#f8f8f8', padding: '10px 0', borderBottom: 'none'}}>
                    <Col xs={2}>{i18n.t('screens:marketingAutomationScreen.customerName')}</Col>
                    <Col xs={2}>{i18n.t('screens:marketingAutomationScreen.customerEmail')}</Col>
                    <Col xs={3}>{i18n.t('screens:marketingAutomationScreen.customerPhone')}</Col>
                    <Col xs={2}>{i18n.t('screens:marketingAutomationScreen.incomingNotifDate')}</Col>
                    <Col xs={2}>{i18n.t('screens:marketingAutomationScreen.coolDownDate')}</Col>
                    <Col xs={1}>{i18n.t('screens:marketingAutomationScreen.blocked')}</Col>
                </Row>
                </Col>
            );
        }
    }

    renderUsedPromoCodesButton(customerId) {
        return (
            <div style={{paddingLeft: '7px'}} className='billingInformationItem'>
                {i18n.t('screens:marketingAutomationScreen.clickToSee')} <span onClick={() => this.props.toggleUsedPromoCodesModal(customerId)} style={{color: '#0288d1', borderBottom: '1px solid #0288d1', cursor: 'pointer'}}>{i18n.t('screens:marketingAutomationScreen.usedPromoCodes')}</span>
            </div>
        )
    }

    renderTableContent = () => {
      return ( (this.props.customers && this.props.customers.content) && this.props.customers.content.length > 0) &&
         this.props.customers.content.map((item, i) => {
            return this.renderSingleItem(item, i);
        })
    }

    renderSingleItem = (customer) => {
        const { informationButtonStyle, headerContainer, reportInfoContainer } = styles;
        const customerInformationRow = `customerInformationRow${customer.id}`;
        const promoCodesInformationRow = `promoCodesInformationRow${customer.id}`;
        const coolDownDate = customer.coolDownDate ? moment(customer.coolDownDate, "DD-MM-YYYY").format("DD-MM-YYYY") : '-';
        const incomingNotificationDate = customer.incomingNotificationDate ? moment(customer.incomingNotificationDate, "DD-MM-YYYY").format("DD-MM-YYYY") : '-';
        
        return (
            <div>
            <Row style={headerContainer} id={customerInformationRow}>
                <Col xs={2} style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between'}}>
                    <Button xs={1} outline="false" style={informationButtonStyle} onClick={() => this.togglePromocodesInfo(customerInformationRow, promoCodesInformationRow, this.state.currentPageNumber)}>
                        <MaterialIcon icon='add_circle' color="#0288D1" size={16} style={{paddingLeft: '0px'}} className={customer.id}/>
                    </Button>
                    <div>{customer.name}</div>
                    {
                        !customer.subscribed ?
                            <div id={`customerSubscibeInfo${customer.id}`} style={{padding: '5px'}}>
                                <MaterialIcon icon="unsubscribe" size={20} color='#0288d1' style={{fontWeight: 'bold'}} />
                                <UncontrolledTooltip placement="center" target={`customerSubscibeInfo${customer.id}`} >
                                    {i18n.t('screens:marketingAutomationScreen.unsubscribed')}
                                </UncontrolledTooltip>
                            </div> : <div style={{width: '30px'}}></div>
                    }
                </Col>
                <Col xs={2}>{customer.email}</Col>
                <Col xs={3}>{customer.formattedPhone}</Col>
                <Col xs={2}>{incomingNotificationDate}</Col>
                <Col xs={2}>{coolDownDate}</Col>
                <Col xs={1}id={customer.id} onClick={() => this.blockUnblock(customer)}>
                    {this.renderIsCustomerBlocked(customer.blocked)}
                </Col>
            </Row>
            <Row style={{display: 'none',  borderBottom: '1px solid #dee2e6', margin: '0px'}} id={promoCodesInformationRow}>
                {this.renderPromoCodesInformation(customer.promotionCodes, customer.customerId)}
                <Row style={{ ...reportInfoContainer, alignItems: 'center', marginBottom: '5px'}} className='billingStatistics'>
                    {this.renderUsedPromoCodesButton(customer.customerId)}
                </Row>
            </Row>
            </div>
        )
    }

    renderIsCustomerBlocked(isCustomerBlocked) {
        return (
            <FormGroup check inline>
                <Input
                    type="checkbox"
                    name="isCustomerBlocked"
                    checked={isCustomerBlocked}
                    value={isCustomerBlocked}
                    onChange={this.updateCheckboxState}
                />
            </FormGroup>
        );
    }

    renderPromoCodesInformation = (promotionCodesList, customerId) => {
        const { reportPromoCodesInfo, reportInfoContainer } = styles;
    
        if (promotionCodesList !== undefined && promotionCodesList !== null && promotionCodesList.length) {
        
            return promotionCodesList.map((promoCode, i) => {
                const isPromoCodeUsed = promoCode.used ? 'Used' : 'Not Used';
                const expireDate =  moment(promoCode.expireDate, "DD-MM-YYYY").format("DD-MM-YYYY")
                
                    return (
                        <Fragment>
                            <Row style={{ ...reportInfoContainer, alignItems: 'center', marginBottom: '5px'}} className='billingStatistics'>
                                <Col xs={4} style={reportPromoCodesInfo}>
                                    <span className='billingInformationItem' style={{fontWeight: 'bold'}}>{i18n.t('screens:marketingAutomationScreen.promoCodeName')}:&nbsp;&nbsp;</span>
                                    <span>&nbsp;{promoCode.value}&nbsp;</span> 
                                </Col>
                                <Col xs={3} style={reportPromoCodesInfo}>
                                        <span className='statusRevenueItem' style={{fontWeight: 'bold'}}>{i18n.t('screens:marketingAutomationScreen.isPromoCodeUsed')}:&nbsp;&nbsp;</span>
                                        <span> &nbsp;{isPromoCodeUsed} &nbsp;&nbsp;&nbsp;&nbsp;
                                        </span>
                                </Col>
                                <Col xs={5} style={reportPromoCodesInfo}>
                                        <span style={{fontWeight: 'bold'}}>{i18n.t('screens:marketingAutomationScreen.promoCodeExpiratioDate')}:&nbsp;&nbsp;</span>
                                        <span style={{paddingBottom: '5px'}}>&nbsp;{expireDate}</span>
                                </Col>
                            </Row>
                        </Fragment>
                    )
            })
        }
    }

    renderSearchOptions = () => {
        return (
            <Container fluid>
                <Row style={{marginBottom: '10px'}}>
                    {this.renderCustomerNameAutoselect()}
                    {this.renderCustomerEmailAutoselect()}
                    {this.renderCustomerPhoneAutoselect()}
                    {this.renderIsBlockedDropdown()} 
                </Row>
                <Row>
                    {this.renderSubmitButton()}
                </Row>
                <Row>
                    {this.renderAddCustomerButton()}
                </Row>
            </Container>
        );
    }

    renderCustomerNameAutoselect = () => {
        return (
            <Col sm={3} style={{ paddingLeft: 0 }} >
                <Input
                    type='text'
                    name='name'
                    placeholder={i18n.t('screens:marketingAutomationScreen.customerName')}
                    value={this.state.searchQuery.name}
                    onChange={this.changeState}
                />
            </ Col>
        );
    }

    renderCustomerEmailAutoselect = () => {
        return (
            <Col sm={3} style={{ paddingLeft: 0 }} >
                <Input
                    type='text'
                    name='email'
                    placeholder={i18n.t('screens:marketingAutomationScreen.customerEmail')}
                    value={this.state.searchQuery.email}
                    onChange={this.changeState}
                />
            </ Col>
        );
    }

    renderCustomerPhoneAutoselect = () => {
        return (
            <Col sm={3} style={{ paddingLeft: 0 }} >
                <Input
                    type='text'
                    name='formattedPhone'
                    placeholder={i18n.t('screens:marketingAutomationScreen.customerPhone')}
                    value={this.state.searchQuery.formattedPhone}
                    onChange={this.changeState}
                />
            </ Col>
        );
    }

    renderIsBlockedDropdown = () => {
        return (
            <Col sm={3} style={{ paddingLeft: 0 }} >
                <Input
                    type="select"
                    name="isBlocked"
                    placeholder={i18n.t('screens:marketingAutomationScreen.blocked')}
                    value={this.state.searchQuery.blocked}
                    onChange={(e) => this.setState({ searchQuery: {
                        ...this.state.searchQuery,
                        blocked: e.target.value
                    }})}>
                    <option value=''>{i18n.t('screens:marketingAutomationScreen.selectUserType')}</option>
                    <option value='true'>{i18n.t('screens:marketingAutomationScreen.blocked')}</option>
                    <option value='false'>{i18n.t('screens:marketingAutomationScreen.notBlocked')}</option>
                </Input>
            </ Col>
        );
    }

    renderPagination() {
        const { flexEnd } = styles; 

        return (
           
            <Container> 
                { this.props.customers ?
                <Row>
                    <Col style={flexEnd}>
                        <Pagination
                            activePage={this.props.customers.number + 1}
                            itemsCountPerPage={DEFAULT_PAGE_SIZE}
                            totalItemsCount={this.props.customers.totalElements}
                            pageRangeDisplayed={DEFAULT_PAGING_RANGE}
                            itemClass='page-item'
                            linkClass='page-link'
                            onChange={this.handlePageChange}
                        />
                    </Col>
                </Row> : null }
            </Container>
        );
    }

    renderSubmitButton = () => {
        const paddingTop = this.props.isAddCustomerListModalOpen ? 'paddingTop: 10' : 'paddingTop: 0'
        return (
            <Col style={{ display: 'flex', justifyContent: 'flex-end', paddingRight: 8, paddingTop }}>
                <Button
                    color='primary'
                    style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginRight: 6 }}
                    onClick={() => this.onClickSubmitButtonAction()}
                >
                    <MaterialIcon icon="search" color="#fff" size={19} />
                    <div style={{ marginLeft: 5 }}>{i18n.t('screens:customerInsightScreen.search')}</div>
                </Button>
            </Col>
        );

    }

    renderAddCustomerButton = () => {
        return (
            <Col style={{ display: 'flex', justifyContent: 'flex-start', paddingRight: 8, paddingTop: 10, paddingLeft: '0px' }}>
                <Button
                    color='primary'
                    style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginRight: 6 }}
                    onClick={() => this.props.toggleAddCustomerListModalOpen()}
                >
                    <MaterialIcon icon="add_circle_outline" color="#fff" size={19} />
                    <div style={{ marginLeft: 5 }}>{i18n.t('screens:marketingAutomationScreen.addCustomer')}</div>
                </Button>
            </Col>
        );

    }

    renderBackToCustomersFiltersButton = () => {
        const { btnStyle } = styles;

        return (
            <div style={{display: 'flex', alignItems: 'center', marginBottom: '20px'}}>
                <Button onClick={() => this.onBackCustomerFilters()} color="primary" style={{ display: 'flex', marginRight: '10px' }}>
                    <span style={{ display: 'flex', alignSelf: 'center' }}><MaterialIcon icon="navigate_before" color="#fff" size={18} /></span>
                    <span style={btnStyle}>{i18n.t('common:buttons.back')}</span>
                </Button>
            </div>
        )
    }

    renderFindCustomer = () => {
        const { addCustomerContainer, textLeft } = styles;
        return (
            <div>
             <Container style={addCustomerContainer}>
                    <Label for="customerPhone">{i18n.t('screens:marketingAutomationScreen.customerPhone')}:</Label>
                    <Input type="text" name="customerPhone" id="customerPhone" value={this.state.customerPhone} onChange={this.changeState} placeholder={i18n.t('screens:marketingAutomationScreen.phoneNumberFindCustomerMsg')} />
                    <br />
                    <p style={textLeft}>
                            {i18n.t('screens:marketingAutomationScreen.noteAddingCustomer')}
                    </p>
                </Container> 
                <Row style={{marginTop:'30px', paddingLeft: '15px', display: 'flex'}}>
                    {this.renderBackToCustomersFiltersButton()}
                    {this.renderSubmitButton()}
                </Row>
             </div>
        )
    }

    renderAddCustomerInfo() {

        const { modalBodyText, managerModalContainer } = styles;
        const { name, phone, email } = this.props.customerToAdd;

        return (
            <div>
                <Container style={managerModalContainer}>
                    <p style={modalBodyText}>
                        {i18n.t('screens:marketingAutomationScreen.existingCustomerMsg')}
                    </p>
                    <p style={modalBodyText}>
                        {i18n.t('common:form.name')}: {name} <br />
                        {i18n.t('common:form.phone')}: {phone} <br />
                        {i18n.t('common:form.email')}: {email}
                    </p>
                    <p style={modalBodyText}>
                            {i18n.t('screens:marketingAutomationScreen.addCustomerMsg')}<br />
                    </p>
                </Container>
                <Row style={{display: 'flex', justifyContent: 'space-between', margin: '13px 1px 1px 0px'}}>
                    <Button outline color="primary" onClick={() => this.onCancelAddCustomer()}>{i18n.t('common:buttons.cancel')}</Button>
                    <Button color="primary" onClick={() => this.onAddCustomer()}><MaterialIcon icon="check" color="#fff" size={20} />{i18n.t('common:buttons.add')}</Button>
                </Row>
            </div>
        );
    }

    renderMode = () => {
       if(this.props.isAddCustomerListModalOpen) {
            return (
                <React.Fragment>
                    { !this.state.isCustomerToAddFound ? 
                        this.renderFindCustomer() :
                        this.renderAddCustomerInfo()
                    }
                </React.Fragment>  
            )
       } else {
            return (
                <React.Fragment>
                    {this.renderSearchOptions()}
                    {this.renderProductSummaryTable()}
                    {this.renderPagination()}
                </React.Fragment>
            )
       }
    }

    render() {
        return (
           this.renderMode()
        );
    }
}

const mapStateToProps = state => {
    return {
        customerToAdd: state.marketingAutomations.customerToAdd,
        countryCode: state.user.countryCode
    }
};

export default connect(mapStateToProps, { 
    loadCustomerAutomationSearch, 
    blockUnblockCustomer,
    checkAddCustomer,
    addCustomer,
    clearCustomerToAdd })(CustomerSearch);

const styles = {
    tableHeaders: {
        padding: '10px',
        fontSize: '16px',
        fontWeight: 'bold',
    },
    tableDetail: {
        padding: '10px',
        fontSize: '14px',   //previously it was 14px not bolded
        fontWeight: 'bold'
    },
    firstRow: {
        //whiteSpace: 'nowrap'
        paddingRight: '0'
    },
    textCenter: {
        textAlign: 'center',
        padding: '10px 5px'
    },
    textRight: {
        textAlign: 'right',
        paddingLeft: '0'
    },
    flexEnd: {
        marginTop: '15px',
        display: 'flex',
        justifyContent: 'flex-end',
        paddingRight: 0
    },
    informationButtonStyle: {
        backgroundColor: 'inherit', 
        border: 'none', 
        paddingRight: '0px',
        boxShadow: 'none',
        marginRight: '5px'
    },
    reportPromoCodesInfo: {
        padding: 5,
        fontSize: 14,
        //display: 'table-cell',
        // justifyContent: 'center',
        padding: '0 7px',
        lineHeight: '20px',
        //textAlign: 'center'
    },
    headerContainer: {
        width: '100%',
        margin: 0,
        display: 'flex',
        justifyContent: 'space-around',
        textAlign: 'center',
        alignItems: 'center',
        padding: '5px 0',
        borderBottom: '1px solid #dee2e6'
    },
    headerContainerNoBorder: {
        width: '100%',
        margin: 0,
        display: 'flex',
        justifyContent: 'space-around',
        textAlign: 'center',
        alignItems: 'center',
        padding: '5px 0'
    },
    reportInfoContainer: {
        width: '60%',
        // marginBottom: 30,
        display: 'flex',
        justifyContent: 'flex-start',
        left: '2.2em',
        marginLeft: '2em'
    },
    btnStyle: {
        display: 'flex',
        alignSelf: 'center',
        padding: '0px 6px 3px'
    },
    addCustomerContainer: {
        backgroundColor: '#f8f8f8',
        paddingTop: 10,
        paddingBottom: 20,
        border: '1px solid #E9ECEF'
    },
    modalBodyText: {
        fontSize: '14px',
        textAlign: 'center'
    },
    managerModalContainer: {
        backgroundColor: '#f8f8f8',
        paddingTop: 10,
        paddingBottom: 10,
        border: '1px solid #E9ECEF'
    },
    textLeft : {
        textAlign: 'left',
        margin: '0px'
    }
}


// WEBPACK FOOTER //
// ./src/components/restaurants/marketingAutomations/CustomerSearch.js